import { render, staticRenderFns } from "./ApplicantComment.vue?vue&type=template&id=495eb752"
import script from "./ApplicantComment.vue?vue&type=script&lang=js"
export * from "./ApplicantComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports